import http from '../common/api';
import {ApiSettings} from "application";
import {isSuccessResponse} from "presentation/common";
import {getStep1FormData} from "./adapter";

const existRequest = async (data) => {
  const defaultResponse = {
    duplicatedOwnerRutOrBill: false,
    duplicatedVin: false,
    rutEmisorMatch: true,
    invalidOwner: false
  };

  const formData = getStep1FormData(data);

  try {
    const response = await http.post(ApiSettings.checkDuplicated, formData, {headers: {'Content-Type': 'multipart/form-data'}});

    if (!isSuccessResponse(response)) {
      return defaultResponse;
    }

    return {
      duplicatedOwnerRutOrBill: response.data?.result?.duplicated_rut_emisor_num_factura ?? false,
      duplicatedVin: response.data?.result?.duplicated_vin ?? false,
      rutEmisorMatch: response.data?.result?.rut_emisor_match ?? false,
      invalidOwner: response.data?.result?.invalid_owner ?? false,
    }

  } catch (e) {
    return defaultResponse;
  }
}

export default existRequest;
